import React from "react";
import { Form } from "react-bootstrap";
import { BootstrapInputProps } from "../types/index";

const BootstrapInput: React.FC<BootstrapInputProps> = ({
  label,
  type = "text",
  placeholder = "",
  value,
  setValue,
  isValid = false,
  isInvalid = false,
  feedback = "",
  disabled = false,
  required = false,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  return (
    <Form.Group
      controlId={`input-${label?.toLowerCase().replace(/\s+/g, "-")}`}
    >
      {label && (
        <Form.Label className="font-weight-bold label-style !text-[30px]">
          {label}
        </Form.Label>
      )}
      <Form.Control
        style={{ fontFamily: "sans-serif" }}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        isValid={isValid}
        isInvalid={isInvalid}
        disabled={disabled}
        required={required}
      />
      {isInvalid && (
        <Form.Control.Feedback type="invalid">{feedback}</Form.Control.Feedback>
      )}
      {isValid && (
        <Form.Control.Feedback type="valid">{feedback}</Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

export default BootstrapInput;
